// =============================================
// SERVICIO DE CATEGORÍAS DE GASTOS
// Maneja las peticiones al API de categorías
// =============================================

import api from './api';

const expenseCategoryService = {
  // GASTOS: Obtener todas las categorías
  getAll: async () => {
    const response = await api.get('/expense-categories');
    return response.data;
  },

  // GASTOS: Obtener solo categorías activas (para selects)
  getActive: async () => {
    const response = await api.get('/expense-categories');
    return response.data;
  },

  // GASTOS: Obtener categoría por ID
  getById: async (id) => {
    const response = await api.get(`/expense-categories/${id}`);
    return response.data;
  },

  // GASTOS: Crear nueva categoría
  create: async (categoryData) => {
    const response = await api.post('/expense-categories', categoryData);
    return response.data;
  },

  // GASTOS: Actualizar categoría
  update: async (id, categoryData) => {
    const response = await api.put(`/expense-categories/${id}`, categoryData);
    return response.data;
  },

  // GASTOS: Eliminar categoría
  delete: async (id) => {
    const response = await api.delete(`/expense-categories/${id}`);
    return response.data;
  },
};

export default expenseCategoryService;
